import '@assets/i18n'
import CssBaseline from '@commons/CssBaseLine'
import AppErrorBoundary from '@commons/ErrorBoundaries/AppErrorBoundary'
import PageTracker from '@commons/Tracker/PageTracker'
import { ThemeProvider } from '@mui/material/styles'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import AppRoutes from '@routesv2/AppRoutes'
import mixpanel from 'mixpanel-browser'
import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import theme from './styles/theme'
// import { PersistGate } from "redux-persist/integration/react";
// import AppErrorBoundary from "@commons/ErrorBoundaries/AppErrorBoundary";
// import PageTracker from "@commons/PageTracker";
// import Routes from "./routes/Routes";
import { persistor, store } from '@redux/store'
import { PersistGate } from 'redux-persist/integration/react'

function App() {
	React.useEffect(() => {
		; (function () {
			window.Chargebee &&
				window.Chargebee.init({
					site: import.meta.env.VITE_APP_CHARGEBEE_SITE_NAME
				})

			let preloaderSvg = document.getElementById('preloader-static')

			setTimeout(() => {
				!!preloaderSvg && preloaderSvg.classList.add('active')
			}, 100)

			setTimeout(() => {
				let preloaderScript = document.getElementById('preloader-script')
				!!preloaderScript && preloaderScript.remove()

				!!preloaderSvg && preloaderSvg.remove()

				let preloaderCss = document.getElementById('preloader-css')
				!!preloaderCss && preloaderCss.remove()
			}, 2000)
		})()
		mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_API_KEY, {
			debug: import.meta.env.VITE_APP_DISABLE_LOGS
		})
	}, [])

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<LocalizationProvider dateAdapter={AdapterMoment}>
						<BrowserRouter>
							<AppErrorBoundary>
								<PageTracker />
								<AppRoutes />
							</AppErrorBoundary>
						</BrowserRouter>
					</LocalizationProvider>
				</PersistGate>
			</Provider>
		</ThemeProvider>
	)
}

export default App
